<template>
  <v-row class="ma-0 pa-0">
    <v-col cols="12" class="pa-0">
      <v-sheet>
        <v-skeleton-loader type="article" v-if="loading" />
        <v-col v-else class="px-6 py-4">
          <v-row class="ma-0" align="center">
            <h2>Your children</h2>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              outlined
              tile
              class="button"
              v-if="!loading"
              @click="addChild"
              >Add child</v-btn
            >
          </v-row>
        </v-col>
      </v-sheet>
      <v-sheet v-if="!loading && this.children.length == 0" class="mb-2">
        <v-skeleton-loader type="article" v-if="loading" />
        <v-col v-else class="px-6 py-8 text-center">
          <span class="text-section-title">No children added</span>
          <p>Click the 'Add child' button to add a child</p>
        </v-col>
      </v-sheet>
      <template
        v-else-if="!loading"
        v-for="(child, idx) in restrictedProfileData.personal.children"
      >
        <v-sheet :key="idx" class="mb-2">
          <v-skeleton-loader type="article" v-if="loading" />
          <v-col v-else class="px-6 py-4">
            <v-row class="ma-0 my-3">
              <v-col cols="12" md="6" class="pa-0">
                <v-row class="ma-0" align="center">
                  <v-col cols="12" md="6" lg="3" class="pa-0">
                    <span class="text-section-title pr-2">First name</span>
                  </v-col>
                  <v-col cols="12" md="6" lg="9" class="pa-0">
                    <v-text-field
                      filled
                      class="field-narrow px-2"
                      v-model="child.firstName"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="6" class="pa-0">
                <v-row class="ma-0" align="center">
                  <v-col
                    cols="12"
                    md="6"
                    lg="3"
                    class="pa-0"
                    :align="$vuetify.breakpoint.mdAndUp ? 'end' : 'start'"
                  >
                    <span class="text-section-title pr-2">Surname</span>
                  </v-col>
                  <v-col cols="12" md="6" lg="9" class="pa-0">
                    <v-text-field
                      filled
                      class="field-narrow px-2"
                      v-model="child.lastName"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="ma-0 my-3">
              <v-col cols="12" lg="6" class="pa-0">
                <v-row class="ma-0" align="center">
                  <v-col cols="12" md="3" class="pa-0">
                    <span class="text-secion-title pr-2">Sex</span>
                  </v-col>
                  <v-col cols="12" md="4" lg="6" class="pa-0">
                    <v-select
                      class="select-narrow px-2"
                      :items="['Male', 'Female']"
                      filled
                      v-model="child.sex"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="ma-0 my-3">
              <v-col cols="12" lg="6" class="pa-0">
                <v-row class="ma-0" align="center">
                  <v-col cols="12" md="3" class="pa-0">
                    <div class="text-section-title">D.O.B</div>
                  </v-col>
                  <v-col cols="12" md="4" lg="5" class="pa-0">
                    <v-menu
                      v-model="dobMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          filled
                          class="field-narrow px-2"
                          :value="child.dob"
                          v-on="on"
                          v-bind="attrs"
                          :clearable="true"
                          @click:clear="removeDOB(child)"
                          readonly
                        />
                      </template>
                      <v-date-picker
                        :value="child.dob"
                        @input="selectDOB($event, child)"
                      />
                    </v-menu>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="ma-0 mt-3 ml-n4">
              <v-btn
                text
                color="primary"
                class="button"
                @click="removeChild(idx)"
                >Remove</v-btn
              >
            </v-row>
          </v-col>
        </v-sheet>
      </template>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ['id', 'profileData', 'restrictedProfileData'],
  data() {
    return {
      dobMenu: false,
      children: this.restrictedProfileData?.personal?.children ?? [],
    }
  },
  computed: {
    loading() {
      return !this.profileData || !this.restrictedProfileData
    },
    hasChildren() {
      return this.children > 0 ?? false
    },
  },
  methods: {
    selectDOB(date, child) {
      child.dob = date
      this.dobMenu = false
    },
    removeDOB(child) {
      delete child.dob
    },
    addChild() {
      this.children.push({})
    },
    async removeChild(idx) {
      this.children.splice(idx, 1)
    },
  },
  watch: {
    restrictedProfileData(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.children = newVal.personal.children
      }
    },
    children: {
      handler(newVal) {
        this.restrictedProfileData.personal.children = newVal
      },
      deep: true,
    },
  },
}
</script>

<style>
</style>